import React, { useEffect, useState } from 'react';
import {AccountsModuleProvider} from './AccountsContext';
import { getPublicImagePath, Modal, useAppDispatch, useAppState } from '@nutastic/nutastic-react-app';
import { WebsiteActions } from '../../../state/actions.mjs';
import togglePageLock from '../../../utils/togglePageLock';
import { ReactSVG } from 'react-svg';
import LoadingOverlay from '../../LoadingOverlay';
import ModalPageContainer from '../../ModalPageContainer';
import { scrollToTopOfAccountPage } from '../../../utils/scrollToTopOfPage';

const componentClass = 'accountsModal';

const AccountsModal = () => {
    const appDispatch = useAppDispatch();
    const {
        accountState: {
            isActive: accountModalIsActive
        } = {},
        authState: {
            isProcessingLogin
        } = {}
    } = useAppState();
    const [showOverlay, setShowOverlay] = useState(false);

    useEffect(() => {
        if (isProcessingLogin) {
            setShowOverlay(true);
        } else {
            setTimeout(() => setShowOverlay(false), 1000);
        }
    }, [isProcessingLogin]);

    useEffect(() => {
        scrollToTopOfAccountPage();
    }, [accountModalIsActive]);

    const onAccountModalClose = () => {
        togglePageLock(false);
        appDispatch({ type: WebsiteActions.ACCOUNT_MODAL_HIDE });
    };

    const renderLoginContent = () => {
        const compClass = 'loginSplash';
        return <div className={compClass}>
            <ReactSVG src={getPublicImagePath('logo--emblem.svg')} className={`${compClass}__logo`} />
            <p>Welcome to the coolest station on this side of space! Let's get you logged in for a Nu experience...</p>
        </div>
    }

    return <ModalPageContainer
        className={componentClass}
        isActive={accountModalIsActive}
        onClose={onAccountModalClose}
        closeButton={<i className="ion-md-close-circle smallerCloseButton" />}
        nodeId="root"
    >
        { (isProcessingLogin || showOverlay) && <LoadingOverlay isOpaque={true} message="Checking those credentials..." /> }
        { accountModalIsActive && <AccountsModuleProvider onReadyToClose={onAccountModalClose} /> }
    </ModalPageContainer>;
};

export default AccountsModal;
